// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-containers-Wiki-WikiEditor-___WikiEditor-module__container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  /* padding: 20px; */
}

/**
 * _______________________________________________________
 *
 *                      Header
 * ________________________________________________________
 */

.app-containers-Wiki-WikiEditor-___WikiEditor-module__header {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: var(--mainBorder);
  display: flex;
  flex-direction: column;
  position: relative;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__green {
  background-color: green;
}
.app-containers-Wiki-WikiEditor-___WikiEditor-module__red {
  background-color: red;
}
.app-containers-Wiki-WikiEditor-___WikiEditor-module__grey {
  background-color: grey;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__headerRightContainer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__headerRight {
  display: flex;
  align-items: flex-start;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__title {
  font-weight: bold;
  font-size: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__btnBorder {
  width: 2px;
  background-color: var(--mainBorderColor);
  height: 30px;
  margin: 0px 10px 0 20px;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__menuButtons {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-end;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__flags {
  margin-top: 5px;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__flagItem {
  display: inline-block;
  color: #fff;
  margin: 3px 5px;
  padding: 0 10px;
  border-radius: 30px;
  font-weight: bold;
}

/**
 * _______________________________________________________
 *
 *                      Content
 * ________________________________________________________
 */

.app-containers-Wiki-WikiEditor-___WikiEditor-module__content {
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  position: relative;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__metadataDate {
  color: grey;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__navItem:not(:first-child) {
  margin-left: 10px;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__notLastVersion {
  color: var(--colors-red);
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__authorName {
  font-weight: bold;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__readOnlyContainer {
  background-color: #fff;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__drawer {
  flex-shrink: 0;
  height: 100%;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-containers-Wiki-WikiEditor-___WikiEditor-module__emptyContent {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  color: lightgrey;
}
`, "",{"version":3,"sources":["webpack://./app/containers/Wiki/WikiEditor/WikiEditor.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;;EAKE;;AAEF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EAEtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EAIE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;EAKE;;AAEF;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  /* padding: 20px; */\n}\n\n/**\n * _______________________________________________________\n *\n *                      Header\n * ________________________________________________________\n */\n\n.header {\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  border-bottom: var(--mainBorder);\n  display: flex;\n  flex-direction: column;\n  // height: 122px;\n  position: relative;\n}\n\n.green {\n  background-color: green;\n}\n.red {\n  background-color: red;\n}\n.grey {\n  background-color: grey;\n}\n\n.headerRightContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.headerRight {\n  display: flex;\n  align-items: flex-start;\n}\n\n.title {\n  font-weight: bold;\n  font-size: 24px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.btnBorder {\n  width: 2px;\n  background-color: var(--mainBorderColor);\n  height: 30px;\n  margin: 0px 10px 0 20px;\n}\n\n.menuButtons {\n  // position: absolute;\n  // right: 0;\n  // bottom: -10px;\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.flags {\n  margin-top: 5px;\n}\n\n.flagItem {\n  display: inline-block;\n  color: #fff;\n  margin: 3px 5px;\n  padding: 0 10px;\n  border-radius: 30px;\n  font-weight: bold;\n}\n\n/**\n * _______________________________________________________\n *\n *                      Content\n * ________________________________________________________\n */\n\n.content {\n  flex: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: flex;\n  position: relative;\n}\n\n.metadataDate {\n  color: grey;\n}\n\n.navItem:not(:first-child) {\n  margin-left: 10px;\n}\n\n.notLastVersion {\n  color: var(--colors-red);\n}\n\n.authorName {\n  font-weight: bold;\n}\n\n.readOnlyContainer {\n  background-color: #fff;\n}\n\n.drawer {\n  flex-shrink: 0;\n  height: 100%;\n}\n\n.wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.emptyContent {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  color: lightgrey;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-containers-Wiki-WikiEditor-___WikiEditor-module__container`,
	"header": `app-containers-Wiki-WikiEditor-___WikiEditor-module__header`,
	"green": `app-containers-Wiki-WikiEditor-___WikiEditor-module__green`,
	"red": `app-containers-Wiki-WikiEditor-___WikiEditor-module__red`,
	"grey": `app-containers-Wiki-WikiEditor-___WikiEditor-module__grey`,
	"headerRightContainer": `app-containers-Wiki-WikiEditor-___WikiEditor-module__headerRightContainer`,
	"headerRight": `app-containers-Wiki-WikiEditor-___WikiEditor-module__headerRight`,
	"title": `app-containers-Wiki-WikiEditor-___WikiEditor-module__title`,
	"btnBorder": `app-containers-Wiki-WikiEditor-___WikiEditor-module__btnBorder`,
	"menuButtons": `app-containers-Wiki-WikiEditor-___WikiEditor-module__menuButtons`,
	"flags": `app-containers-Wiki-WikiEditor-___WikiEditor-module__flags`,
	"flagItem": `app-containers-Wiki-WikiEditor-___WikiEditor-module__flagItem`,
	"content": `app-containers-Wiki-WikiEditor-___WikiEditor-module__content`,
	"metadataDate": `app-containers-Wiki-WikiEditor-___WikiEditor-module__metadataDate`,
	"navItem": `app-containers-Wiki-WikiEditor-___WikiEditor-module__navItem`,
	"notLastVersion": `app-containers-Wiki-WikiEditor-___WikiEditor-module__notLastVersion`,
	"authorName": `app-containers-Wiki-WikiEditor-___WikiEditor-module__authorName`,
	"readOnlyContainer": `app-containers-Wiki-WikiEditor-___WikiEditor-module__readOnlyContainer`,
	"drawer": `app-containers-Wiki-WikiEditor-___WikiEditor-module__drawer`,
	"wrapper": `app-containers-Wiki-WikiEditor-___WikiEditor-module__wrapper`,
	"emptyContent": `app-containers-Wiki-WikiEditor-___WikiEditor-module__emptyContent`
};
export default ___CSS_LOADER_EXPORT___;
